import PropTypes from 'prop-types';

export function nowLocal() {
	const d = new Date();
	d.setSeconds(0, 0);
	return d.toISOString().slice(0, 16);
}

/**
 * Send-now vs. send-later switch for automated template sends (email + letter).
 * 'now' resolves dueAt to the current time, which both backend schedulers treat as "send immediately".
 */
export const ScheduleModeToggle = ({ value, onChange }) => (
	<div className="flex gap-1.5">
		<button
			type="button"
			onClick={() => onChange('now')}
			className={`flex-1 text-xs px-2.5 py-2 rounded-control border transition-colors ${value === 'now' ? 'border-primary-300 bg-primary-100 text-primary-700 font-medium' : 'border-bgBase-500 text-bgBase-800 hover:border-bgBase-600'}`}
		>
			Sofort senden
		</button>
		<button
			type="button"
			onClick={() => onChange('later')}
			className={`flex-1 text-xs px-2.5 py-2 rounded-control border transition-colors ${value === 'later' ? 'border-primary-300 bg-primary-100 text-primary-700 font-medium' : 'border-bgBase-500 text-bgBase-800 hover:border-bgBase-600'}`}
		>
			Für später planen
		</button>
	</div>
);
ScheduleModeToggle.propTypes = { value: PropTypes.string, onChange: PropTypes.func };

/**
 * Resolves dueAt for a template send. An immediate send is expressed as "now" rather than a null
 * dueAt, because the backend schedulers key off dueAt to decide when to fire.
 * @param {{isImmediate: boolean, dueAt: string}} state
 * @returns {string|null} ISO timestamp
 */
export function resolveDueAt({ isImmediate, dueAt }) {
	if (isImmediate) return new Date().toISOString();
	return dueAt ? new Date(dueAt).toISOString() : null;
}

export const SubModeToggle = ({ value, onChange }) => (
	<div className="flex bg-bgBase-400 rounded-control p-0.5">
		<button
			type="button"
			onClick={() => onChange('todo')}
			className={`text-xs px-2.5 py-1 rounded-control transition-colors ${value === 'todo' ? 'bg-white font-medium text-text' : 'text-bgBase-800'}`}
		>
			Planen
		</button>
		<button
			type="button"
			onClick={() => onChange('log')}
			className={`text-xs px-2.5 py-1 rounded-control transition-colors ${value === 'log' ? 'bg-white font-medium text-text' : 'text-bgBase-800'}`}
		>
			Eintragen
		</button>
	</div>
);
SubModeToggle.propTypes = { value: PropTypes.string, onChange: PropTypes.func };
